import React from 'react';
import { Heading } from '@chakra-ui/react';
import auth from '@udacity/ureact-hoth';

import { useFetchMeQuery } from 'app/apis/reviews';
import Card from 'app/common/components/card/card';
import { eligibleProjectLanguagesFromApproved } from 'app/helpers/project-language-helper';
import { useGetMentorQuery } from 'app/mentor/queries/enhanced';
import styles from 'app/queue/views/overview/queue/queue.module.scss';
import { ReviewQueue } from 'app/queue/views/overview/queue/review-queue';
import { PlagiarismQueue } from 'app/queue/views/overview/queue/plagiarism-queue';
import { QuestionQueue } from 'app/queue/views/overview/queue/question-queue';
import { useTranslation } from 'react-i18next';

export const Queue: React.FC = () => {
  const { t } = useTranslation();
  const uid = auth.getCurrentUserId() || '';
  const { data: mentorData } = useGetMentorQuery({ uid }, { skip: !uid });
  const { data: reviewsMe } = useFetchMeQuery();
  const canJoinPlagiarismQueue = Boolean(reviewsMe?.can_join_plagiarism_queue);

  const canQueueForQuestions = eligibleProjectLanguagesFromApproved(mentorData?.mentor?.approved_languages).includes(
    'en-us'
  );

  return (
    <Card className={styles['queue-controls']}>
      <div className={styles['header-row']}>
        <div className={styles['heading-container']}>
          <Heading size="h6" as="h6" color="gray.600" fontSize="sm" textTransform="uppercase">
            {t('queue.queue')}
          </Heading>
        </div>
        <div className={styles['heading-container']}>
          <Heading size="h6" as="h6" color="gray.600" fontSize="sm" textTransform="uppercase">
            {t('queue.time')}
          </Heading>
        </div>
      </div>

      <ReviewQueue />

      {canJoinPlagiarismQueue && <PlagiarismQueue />}

      {canQueueForQuestions && <QuestionQueue />}
    </Card>
  );
};

export default Queue;
